import { EProblemReportStatus } from '@constants';

export const ProblemReportsTranslations = {
  PROBLEM_REPORTS: {
    es: 'Informes de problemas',
    en: 'Problem reports',
    cat: 'Informes de problemes',
    eus: 'Arazoen txostenak',
    pt: 'Relatórios de problemas'
  },
  PROBLEM_REPORTS_TOTAL: {
    es: '{{total}} reportes',
    en: '{{total}} reports',
    cat: '{{total}} reportis',
    eus: '{{total}} txostenak',
    pt: '{{total}} relatórios'
  },
  TITLE: {
    es: 'Título',
    en: 'Title',
    cat: 'Títol',
    eus: 'Titulazioa',
    pt: 'Título'
  },
  [EProblemReportStatus.REVIEWED]: {
    es: 'Revisado',
    en: 'Reviewed',
    cat: 'Revisat',
    eus: 'Berrikusita',
    pt: 'Revisado'
  },
  [EProblemReportStatus.IN_REVIEW]: {
    es: 'En revisión',
    en: 'In review',
    cat: 'En revisió',
    eus: 'Berrikuspenan',
    pt: 'Em revisão'
  },
  [EProblemReportStatus.NOT_REVIEWED]: {
    es: 'No revisado',
    en: 'Not reviewed',
    cat: 'No revisat',
    eus: 'Ez da berrikusi',
    pt: 'Não revisado'
  },
  NO_PROBLEM_REPORTS: {
    es: '¡Todo limpio! No tienes reportes. 😀',
    en: 'All clean! You have no reports. 😀',
    cat: 'Tot net! No tens reportis. 😀',
    eus: 'Guztia garbia! Ez duzu txostenak. 😀',
    pt: 'Tudo limpo! Você não tem relatórios. 😀'
  },
  DRAWER_TITLE: {
    es: 'Reporte de problema',
    en: 'Report',
    cat: 'Reporti',
    eus: 'Txostena',
    pt: 'Relatório'
  },
  DESCRIPTION: {
    es: 'Descripción',
    en: 'Description',
    cat: 'Descripció',
    eus: 'Deskribapena',
    pt: 'Descrição'
  },
  REPORTED_BY: {
    es: 'Reportado por',
    en: 'Reported by',
    cat: 'Reportat per',
    eus: 'Txostenak',
    pt: 'Relatórios'
  },
  STATUS: {
    es: 'Estado',
    en: 'Status',
    cat: 'Estat',
    eus: 'Egoera',
    pt: 'Estado'
  },
  CREATED_AT: {
    es: 'Fecha de creación',
    en: 'Creation date',
    cat: 'Data de creació',
    eus: 'Sortze data',
    pt: 'Data de criação'
  },
  REPORT_SENT_SUCCESSFULLY: {
    es: 'Hemos recibido tu reporte y estamos trabajando para resolver el problema lo antes posible.',
    en: 'We have received your report and are working to resolve the issue as soon as possible.',
    cat: 'Hem rebut la teva informació i estem treballant per resoldre el problema el més aviat possible.',
    eus: 'Jaso dugu zure txostena eta aprobetxatzen ari gara arazoak azkartu dezaten.',
    pt: 'Recebemos seu relatório e estamos trabalhando para resolver o problema o mais rápido possível.'
  },
  STATUS_SUCCESSFULLY_UPDATED: {
    es: 'El estado del reporte se ha actualizado correctamente.',
    en: 'The status of the report has been updated correctly.',
    cat: "L'estat del reporti s'ha actualitzat correctament.",
    eus: 'Txostenaren egoera behar bezala eguneratu da.',
    pt: 'O estado do relatório foi atualizado com sucesso.'
  },
  QUESTION_TITLE: {
    es: 'Título pregunta',
    en: 'Question title',
    cat: 'Títol de la pregunta',
    eus: 'Galderaren titulua',
    pt: 'Título da questão'
  },
  QUESTION_ANSWERS: {
    es: 'Respuestas',
    en: 'Answers',
    cat: 'Respostes',
    eus: 'Erantzunak',
    pt: 'Respostas'
  },
  QUESTION_DETAIL: {
    es: 'Detalle pregunta',
    en: 'Question detail',
    cat: 'Detall de la pregunta',
    eus: 'Galderaren xehetasunak',
    pt: 'Detalhes da questão'
  },
  COURSE: {
    es: 'Curso',
    en: 'Course',
    cat: 'Curs',
    eus: 'Kurtsua',
    pt: 'Curso'
  },
  SECTION: {
    es: 'Sección',
    en: 'Section',
    cat: 'Secció',
    eus: 'Atala',
    pt: 'Seção'
  },
  ACTIVITY_NAME: {
    es: 'Nombre actividad',
    en: 'Activity name',
    cat: "Nom de l'activitat",
    eus: 'Jardueraren izena',
    pt: 'Nome da atividade'
  },
  ACTIVITY_DESCRIPTION: {
    es: 'Descripción actividad',
    en: 'Activity description',
    cat: "Descripció de l'activitat",
    eus: 'Jardueraren deskribapena',
    pt: 'Descrição da atividade'
  },
  COURSE_DETAIL: {
    es: 'Detalle del curso',
    en: 'Course detail',
    cat: 'Detall del curs',
    eus: 'Kurtsuaren xehetasunak',
    pt: 'Detalhes do curso'
  },
  REPORT_DELETED_SUCCESSFULLY: {
    es: 'El reporte se ha eliminado correctamente.',
    en: 'The report has been deleted correctly.',
    cat: "El reporti s'ha eliminat correctament.",
    eus: 'Txostena behar bezala ezabatu da.',
    pt: 'O relatório foi excluído com sucesso.'
  },
  DELETE_REPORT: {
    es: 'Eliminar reporte',
    en: 'Delete report',
    cat: 'Eliminar reporti',
    eus: 'Txostena ezabatu',
    pt: 'Excluir relatório'
  },
  DELETE_REPORT_CONFIRMATION: {
    es: '¿Estás seguro de que quieres eliminar estos reportes? Esta acción no se puede deshacer.',
    en: 'Are you sure you want to delete these reports? This action cannot be undone.',
    cat: '¿Estàs segur que vols eliminar aquests reportis? Aquesta acció no es pot desfer.',
    eus: '¿Ziur zaude txosten hauek ezabatu nahi dituzula? Ekintza hau ezin da desegin.',
    pt: 'Tem certeza que deseja excluir estes relatórios? Esta ação não pode ser desfeita.'
  },
  DELETE: {
    es: 'Eliminar',
    en: 'Delete',
    cat: 'Eliminar',
    eus: 'Ezabatu',
    pt: 'Excluir'
  },
  CANCEL: {
    es: 'Cancelar',
    en: 'Cancel',
    cat: 'Cancel·lar',
    eus: 'Ezeztatu',
    pt: 'Cancelar'
  },
  TYPE: {
    es: 'Tipo',
    en: 'Type',
    cat: 'Tipus',
    eus: 'Mota',
    pt: 'Tipo'
  },
  ACTIVITY: {
    es: 'Actividad',
    en: 'Activity',
    cat: 'Activitat',
    eus: 'Jarduerak',
    pt: 'Atividades'
  },
  QUESTION: {
    es: 'Pregunta',
    en: 'Question',
    cat: 'Pregunta',
    eus: 'Galdera',
    pt: 'Questão'
  },
  FILTERS: {
    es: 'Filtros',
    en: 'Filters',
    cat: 'Filtres',
    eus: 'Iragazkiak',
    pt: 'Filtros'
  },
  TAGS: {
    es: 'Formaciones',
    en: 'Tags',
    cat: 'Formacions',
    eus: 'Formakuntzak',
    pt: 'Formações'
  },
  SELECT_A_TAG_TO_FILTER: {
    es: 'Selecciona una formación',
    en: 'Select a tag',
    cat: 'Selecciona una formació',
    eus: 'Hautatu formakuntza bat',
    pt: 'Selecione uma formação'
  },
  PROBLEM_REPORT_NOT_FOUND: {
    es: 'No se ha encontrado el recurso asociado al reporte de problema. Por favor, borra este reporte.',
    en: 'The resource associated with the problem report was not found. Please delete this report.',
    cat: "No s'ha trobat el recurs associat al reporti de problema. Si us plau, esborra aquest reporti.",
    eus: 'Ez da aurkitu arazoaren txostenarekin erlazionatutako baliabidea. Mesedez, ezabatu txostena hau.',
    pt: 'Não foi encontrado o recurso associado ao relatório de problema. Por favor, exclua este relatório.'
  }
};
